<template>
    <div class="promotion-box">
        <a-row :gutter="[15, 0]">
            <a-col :span="24">
                <a-alert :message="$t('goods.message_1' /* 限时促销：按时间段设定门票价格 */)" type="info" show-icon />
            </a-col>
            <a-col :span="24">
                <a-input-search :placeholder="$t('goods.enter_name_no' /* 请输入门票名称/编号 */)" class="mt20 name-search" style="width: 400px" allowClear enter-button @search="onSearch" />
            </a-col>
            <a-col :span="24" class="mt20">
                <a-button type="primary" icon="plus" @click="handleAdd()">{{ $t('web.add' /* 添加 */) }}</a-button>
            </a-col>
        </a-row>

        <a-table ref="table" :rowKey="record => record.id" :columns="columns" :data-source="dataSource" :pagination="pagination" class="mt15" size="middle" @change="getListData" :scroll="{ x: 800 }">
            <span slot="index" slot-scope="text, record, index">
                {{ index + 1 }}
            </span>

            <span slot="name" slot-scope="text, record">
                <a-button @click="handleShowInfoData(record)" type="link">{{ text }}</a-button>
            </span>

            <span slot="status" slot-scope="text, record">
                <!--                <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />-->
                <a-switch @change="handleChangeStatus(record)" :checked="record.status == 1" :checked-children="$t('web.open' /* 开启 */)" :un-checked-children="$t('web.close' /* 关闭 */)" />
            </span>

            <span slot="action" slot-scope="text, record">
                <a @click="handleShowInfoData(record, true)">{{ $t('web.edit' /* 编辑 */) }}</a>
                <a-divider type="vertical" />
                <a @click="handleDelete(record)" class="del-button">{{ $t('web.delete' /* 删除 */) }}</a>
            </span>
        </a-table>

        <!--    编辑&新增    -->
        <promotionEdit ref="promotionEdit" :visible="visible" :dataInfo="dataInfo" @ok="handleEditOk" @cancel="handleEditCancel" />
        <!--    详情    -->
        <ladderInfo
            :visible="infoVisible"
            :dataInfo="dataInfo1"
            @close="
                infoVisible = false;
                dataInfo1 = {};
            "
        />
    </div>
</template>

<script>
import promotionEdit from '@/views/goods-module/components/promotion-edit.vue';
import ladderInfo from '@/views/goods-module/components/ladder-info.vue';
const statusTypeFilter = {
    0: 'warning',
    1: 'processing'
};
const statusFilter = {
    0: '已暂停',
    1: '进行中'
};
export default {
    name: 'LadderPromotion',
    components: {
        promotionEdit,
        ladderInfo
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t('goods.index' /* 序号 */),
                    scopedSlots: { customRender: 'index' },
                    align: 'center',
                    fixed: 'left'
                },
                {
                    title: this.$t('goods.promotion_name' /*促销活动名称 */),
                    dataIndex: 'name',
                    align: 'center',
                    scopedSlots: { customRender: 'name' },
                    fixed: 'left'
                },
                {
                    title: this.$t('goods.promotion_status' /* 促销状态 */),
                    dataIndex: 'status',
                    align: 'center',
                    scopedSlots: { customRender: 'status' }
                },
                /*{
                        title : '适用门票',
                        dataIndex : 'applicableGoods',
                        align : 'center'
                    },*/
                {
                    title: this.$t('goods.start_time' /* 开始时间 */),
                    dataIndex: 'start_time',
                    align: 'center'
                },
                {
                    title: this.$t('goods.end_time' /* 结束时间 */),
                    dataIndex: 'end_time',
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' },
                    fixed: 'right'
                }
            ],
            dataSource: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            visible: false,
            dataInfo: {},
            dataInfo1: {},
            infoVisible: false
        };
    },
    filters: {
        statusTypeFilter(value) {
            return statusTypeFilter[value];
        },
        statusFilter(value) {
            return statusFilter[value];
        }
    },
    created() {
        this.getListData();
    },
    methods: {
        getListData() {
            let data = {
                page: this.pagination.current,
                limit: this.pagination.pageSize,
                ...this.searchParams
            };
            this.$request.get({ url: 'getSaleTiered', data }).then(res => {
                this.pagination.total = parseInt(res.data.total);
                this.dataSource = res.data.data;
            });
        },
        onSearch(value) {
            this.searchParams = {
                name: value
            };
            this.pagination.current = 1;
            this.getListData();
        },
        handleAdd() {
            this.dataInfo = {};
            this.visible = true;
        },
        // 删除
        handleDelete(data) {
            this.$confirm({
                title: this.$t('web.tips' /* 提示 */),
                content: this.$t('goods.delete_confirm_ticket' /* 确定删除该门票吗？ */),
                okText: this.$t('web.ok' /* 确定 */),
                cancelText: this.$t('web.cancel' /* 取消 */),
                onOk: () => {
                    this.$request.post({ url: 'setTieredStatus', data: { ids: data.id, type: -1 } }).then(res => {
                        this.pagination.current = 1;
                        this.getListData();
                    });
                }
            });
        },
        handleChangeStatus(data) {
            let status = data.status == 1 ? 0 : 1;
            this.$request.post({ url: 'setTieredStatus', data: { ids: data.id, type: status } }).then(res => {
                this.pagination.current = 1;
                this.getListData();
            });
        },
        handleShowInfoData(data, lock) {
            // 编辑
            if (lock) {
                this.dataInfo = data;
                this.visible = true;
            } else {
                // 展示详情
                this.dataInfo1 = data;
                this.infoVisible = true;
            }
        },
        handleEditOk() {
            this.dataInfo = {};
            this.pagination.current = 1;
            this.getListData();
            this.visible = false;
        },
        handleEditCancel() {
            this.dataInfo = {};
            this.visible = false;
        }
    }
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
    .name-search {
        width: 100% !important;
    }
}
</style>